import React, { Component } from 'react';
import LocaleStringsService from '../Services/LocaleStringsService.js';
import LocaleStringsList from '../Components/LocaleStrings/LocaleStringsList.js';
import { withApi } from '../Providers/WebServiceProvider.js';
import Locale from '../Entities/Locale.js';
import ability from '../abilities'

class Translate extends Component
{
	constructor(props) {
		super(props);

		this.state = {
			strings: [],
			locale: null,
			isLoaded: false
		}

		this.stringsService = new LocaleStringsService(props.webServiceContext.getApi());
	}
 
	updateAction = (locale, strings, mode) => {
		const that = this;

		return this.stringsService.bulk(locale, strings, mode).then(function (updatedStrings) {
      updatedStrings.map(function (string) {
        string.props.isDirty = false;
      });

      that.setState({ strings: updatedStrings });

      return updatedStrings;
		});
	}

	fetchStrings(locale) {
		var that = this;

		this.setState({ isLoaded: false });

		this.stringsService.fetchForLocale(locale)
			.then(function (results) {
				that.setState({ strings: results.strings, locale: results.locale, isLoaded: true });
			})
			.catch(function () {
				that.setState({ strings: [], isLoaded: true });
			});
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.match.params.locale !== nextProps.match.params.locale) {
			this.fetchStrings(nextProps.match.params.locale);
		}
	}

	componentDidMount() {
		this.fetchStrings(this.props.match.params.locale);
	}

  render () {
  	const localeObj = new Locale({ key: this.props.match.params.locale });

  	if (this.state.isLoaded) {
	 	  return (
	 	  	<div className="section">
		 	  	<div className="page-section">
		 	  		<LocaleStringsList 
		 	  			updater={this.updateAction} 
		 	  			locale={this.state.locale} 
		 	  			strings={this.state.strings}
		 	  			mode="translate"
		 	  			readonly={ability.can('read', localeObj) && !ability.can("translate", localeObj)}
		 	  		/>
				  </div>
				 </div>
		  );
  	} else {
  		return ('Loading...');
  	}
  }
}

export default withApi(Translate);


// WEBPACK FOOTER //
// ./src/Pages/Translate.js